<template>
  <q-toggle
    v-if="isEnabled"
    :model-value="modelValue"
    @update:model-value="(val) => emit('update:modelValue', val)"
    v-bind="$attrs"
  >
    <template v-for="(_, slot) in $slots" v-slot:[slot]="slotProps">
      <slot :name="slot" v-bind="slotProps" />
    </template>
  </q-toggle>
  <CuiToggleSwitch
    v-else
    :model-value="modelValue"
    @update:model-value="(val) => emit('update:modelValue', val)"
    v-bind="$attrs"
  >
    <slot />
  </CuiToggleSwitch>
</template>

<script setup lang="ts">
import { useFeatureFlags } from "@/composables/useFeatureFlags";

const { isEnabled: checkEnabled } = useFeatureFlags();
const isEnabled = checkEnabled("dtpToggle");
type Props = {
  modelValue?: boolean;
};

defineProps<Props>();

const emit = defineEmits<{
  "update:modelValue": [value: boolean];
}>();

defineOptions({
  name: "dtpToggle",
  inheritAttrs: true
});
</script>
